import { Grid } from '@zillow/constellation';
import React, { ReactNode, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Card, Header1Text } from 'ui-toolkit';

const StickySidecar = styled.div<{ top: number | undefined }>`
  position: sticky;
  ${(props) => (props.top !== undefined ? `top:${props.top}px;` : '')};
`;

export interface IIncomingTransactionLayoutProps {
  table: ReactNode;
  sidecar: ReactNode;
}

export const IncomingTransactionLayout: React.FC<IIncomingTransactionLayoutProps> = ({ table, sidecar }) => {
  const [stickyTop, setStickyTop] = useState<number | undefined>();

  const stickyRef = useCallback((node: HTMLDivElement) => {
    if (node) {
      setStickyTop(node.offsetTop);
    }
  }, []);

  return (
    <Grid display="grid" gridTemplateColumns="1fr max-content" gridAutoFlow="column" padding={0} alignItems="start">
      <Card title={<Header1Text>Incoming Transactions</Header1Text>} ref={stickyRef}>
        {table}
      </Card>
      <StickySidecar top={stickyTop}>{sidecar}</StickySidecar>
    </Grid>
  );
};
